import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import { nanoid } from 'nanoid';

type SnowplowSchema = string;

export function emitEvent<T extends object>(schema: SnowplowSchema, eventData?: T): void {
    const eventDetails = {
        schema,
        data: {
            Event_id: nanoid(),
            ...eventData,
        },
    };

    trackSelfDescribingEvent({
        event: eventDetails,
    });
}
